export default __webpack_public_path__ + "static/media/traffic_light.a9b92b04.svg";